/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ValidateProjectIdInput = {|
  projectId?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type ValidateProjectIdMutationVariables = {|
  input: ValidateProjectIdInput
|};
export type ValidateProjectIdMutationResponse = {|
  +validateProjectId: ?{|
    +valid: ?string
  |}
|};
export type ValidateProjectIdMutation = {|
  variables: ValidateProjectIdMutationVariables,
  response: ValidateProjectIdMutationResponse,
|};
*/


/*
mutation ValidateProjectIdMutation(
  $input: ValidateProjectIdInput!
) {
  validateProjectId(input: $input) {
    valid
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ValidateProjectIdInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ValidateProjectIdPayload",
    "kind": "LinkedField",
    "name": "validateProjectId",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "valid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ValidateProjectIdMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ValidateProjectIdMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "ValidateProjectIdMutation",
    "operationKind": "mutation",
    "text": "mutation ValidateProjectIdMutation(\n  $input: ValidateProjectIdInput!\n) {\n  validateProjectId(input: $input) {\n    valid\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e0afdb5228dd9ddeac4ec8fe4ec3e2b5';

module.exports = node;
